import {ISectionMenuL1, ISectionMenuL2} from "../interface/ISection";

export class HelperCatalog {

    static getUrlList(el1: ISectionMenuL1, el2: ISectionMenuL2 | null) {
        let url='/catalog/'+el1.code;
        if (el2 !== null) {
            url+='/'+el2.code;
        }
        return url;
    }

    static getUrlCatalog(code1:string,code2:string|null){
        let url='/catalog/'+code1;
        if (code2 !== null) {
            url+='/'+code2;
        }
        return url;
    }
}
